import { Roles } from '../../auth/types'

export type MfeRouteTarget = '_blank' | '_self' | '_parent' | '_top' | 'framename' | undefined

export enum MfeRouteGroup {
  None = 0,
  Freights = 1,
  Financial = 2,
  Register = 3,
  Cockpit = 4,
  Dochub = 5,
}

export type VisibleMfeRouteGroup = Exclude<MfeRouteGroup, MfeRouteGroup.None>

export interface IMfeRoute {
  label: string
  path: string
  group: MfeRouteGroup
  acceptedRoles: Roles[]
  target: MfeRouteTarget
}
